"use client";

import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";

import { cx } from "../../cx";
import styles from "./radio-group.module.css";

type WithClassName<P> = Omit<P, "className"> & { className?: string };

function RadioGroup<T = string>({
  className,
  ...props
}: WithClassName<RadioGroupPrimitive.Props<T>>) {
  return (
    <RadioGroupPrimitive
      data-tui=""
      data-slot="radio-group"
      className={cx(styles.group, className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: WithClassName<RadioPrimitive.Root.Props>) {
  return (
    <RadioPrimitive.Root
      data-tui=""
      data-slot="radio-group-item"
      className={cx(styles.item, className)}
      {...props}
    >
      {/* Unmounted while unselected, so the empty state is empty. */}
      <RadioPrimitive.Indicator
        data-slot="radio-group-indicator"
        className={styles.indicator}
      />
    </RadioPrimitive.Root>
  );
}

export { RadioGroup, RadioGroupItem };
